<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step11-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep($event)" (onPrevStep)= "prevStep($event)"></app-quote-step11-desktop>
<!-- </ng-container>

<ng-container *ngIf="screenWidth <= 768">
  <app-quote-step11-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step11-mobile>
</ng-container> -->